"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (values, duration, options) {
    // Linear interpolation
    var lerp = function (source, target, amount) { return source + amount * (target - source); };
    // Validation methods
    var checkFunc = function (f) { return (typeof f === 'function' ? f : function (_) { return _; }); };
    // Ensure methods
    var onComplete = checkFunc(options.onComplete);
    var onUpdate = checkFunc(options.onUpdate);
    // https://gist.github.com/gre/1650294
    var ease = function (t) { return (--t) * t * t + 1; };
    // Animation start time
    var start = Date.now();
    var to = values[0], from = values[1];
    if (isNaN(Number(to)) || isNaN(Number(from))) {
        return false;
    }
    // Create & run animation function
    var animation = function () {
        var now = Date.now();
        var t = duration > 0 ? (now - start) / duration : 1;
        var progress = ease(t);
        from = lerp(from, to, progress);
        // If complete...
        if (t >= 1) {
            // Final update for all keys
            from = to;
            onUpdate([to, from]);
            onComplete([to, from]);
        }
        else {
            // Run update callback and loop until finished
            onUpdate([to, from]);
            requestAnimationFrame(animation);
        }
    };
    animation();
});
